import styled from "styled-components";
import { theme } from "@Styled";

export const NPSVoteContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0 0.5rem;
`;

export const SliderSection = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

export const SliderWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0;
    margin-top: 1rem;
    margin-bottom: 1rem;

    .MuiSlider-root {
        width: 100%;

        .MuiSlider-track {
            background: linear-gradient(
                90deg,
                #ff1493,
                #8b0099,
                #4169e1,
                #00bcd4
            );
            height: 8px;
            border-radius: 4px;
        }

        .MuiSlider-thumb {
            width: 28px;
            height: 28px;
            background-color: white;
            border: 3px solid ${theme.palette.common.tbCyan};
            box-shadow: 0 2px 8px rgba(0, 188, 212, 0.3);
            transition: all 0.2s ease;

            &:hover {
                box-shadow: 0 4px 12px rgba(0, 188, 212, 0.5);
                transform: scale(1.1);
            }

            &.Mui-focusVisible {
                box-shadow: 0 0 0 8px rgba(0, 188, 212, 0.15);
            }
        }

        .MuiSlider-rail {
            background-color: #e0e0e0;
            height: 8px;
            border-radius: 4px;
        }

        .MuiSlider-mark {
            background-color: #bdbdbd;
            height: 6px;
            width: 2px;
            margin-top: 1px;
        }

        .MuiSlider-markLabel {
            font-size: 0.875rem;
            color: ${theme.palette.common.darkGray};
            margin-top: 0.5rem;
            font-weight: 500;
        }
    }
`;

export const UserVoteDisplay = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    background-color: #e8f5e9;
    border-left: 4px solid #4caf50;
    border-radius: 4px;
    font-size: 0.9rem;
    color: #2e7d32;
    font-weight: 500;
`;

export const AdminNoticeContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    background-color: #fff3e0;
    border-left: 4px solid #ff9800;
    border-radius: 4px;
    font-size: 0.9rem;
    color: #e65100;
    font-weight: 500;
`;

export const LoadingSpinner = styled.div`
    display: inline-block;
    width: 1rem;
    height: 1rem;
    border: 2px solid #e0e0e0;
    border-top-color: ${theme.palette.common.tbCyan};
    border-radius: 50%;
    animation: spin 0.6s linear infinite;

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`;

export const ResultBar = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
`;

export const ResultBarLabel = styled.div`
    width: 30px;
    font-size: 0.875rem;
    font-weight: 600;
    color: ${theme.palette.common.black};
    text-align: center;
`;

export const ResultBarContainer = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const ResultBarFill = styled.div<{
    percentage: number;
    isUserChoice: boolean;
}>`
    height: 24px;
    background: ${(props) =>
        props.isUserChoice ? "#4caf50" : theme.palette.common.tbCyan};
    border-radius: 4px;
    width: ${(props) => props.percentage}%;
    min-width: ${(props) => (props.percentage > 0 ? "4px" : "0px")};
    transition: width 0.3s ease;
`;

export const ResultBarInfo = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 60px;
    font-size: 0.75rem;
    color: ${theme.palette.common.darkGray};
    text-align: right;
`;

export const AuthorScaleGrid = styled.div`
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 1rem;
`;

export const AuthorScaleItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
`;

export const AuthorScorePercentage = styled.span`
    font-size: 0.65rem;
    font-weight: 600;
    color: ${theme.palette.common.darkGray};
    min-height: 14px;
`;

export const AuthorScoreBox = styled.div`
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    width: 32px;
    height: 80px;
    border-radius: 4px;
    background-color: ${theme.palette.common.lightGray};
    border: 1px solid #ddd;
    overflow: hidden;
`;

export const AuthorScoreFill = styled.div<{ percentage: number }>`
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: #64b5f6;
    height: ${(props) => props.percentage}%;
    transition: height 0.3s ease;
`;

export const AuthorScoreNumber = styled.span`
    position: relative;
    z-index: 1;
    color: ${theme.palette.common.darkGray};
    font-size: 0.875rem;
    font-weight: 500;
`;

export const ScaleLabelsRow = styled.div<{ $variant?: "voter" | "author" }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${(props) =>
        props.$variant === "voter" ? "margin: 0 0 1rem;" : "margin-top: 1rem;"}
`;

export const ScaleLabel = styled.span`
    color: ${theme.palette.common.darkGray};
    font-size: 0.7rem;
    text-align: left;

    &:last-child {
        text-align: right;
    }
`;
